module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "h1"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "h1"
    }
  }, [_c('p', {
    staticClass: "common"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "paraToc"
  }, [_c('a', {
    attrs: {
      "id": "h1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/04_maps#h2"
    }
  }, [_vm._v("List of Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "paraToc"
  }, [_c('a', {
    attrs: {
      "href": "#/05_plates#h3"
    }
  }, [_vm._v("List of Plates")])]), _vm._v(" "), _c('p', {
    staticClass: "paraToc"
  }, [_c('a', {
    attrs: {
      "href": "#/06_acknowledgements#h4"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "paraToc1"
  }, [_c('a', {
    attrs: {
      "href": "#/07_contributors#h5"
    }
  }, [_vm._v("List of Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "paraToc"
  }, [_c('a', {
    attrs: {
      "href": "#/08_introduction#h6"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "paraToc"
  }, [_c('a', {
    attrs: {
      "href": "#/09_chapter01#h7"
    }
  }, [_vm._v("Chapter 1 Garnet Wolseley – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Steven J Corvi")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraToc"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter02#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2 Evelyn Wood – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Stephen Manning")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraToc"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter03#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3 Redvers Buller – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Stephen M Miller")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraToc"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter04#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4 George Colley – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Ian F W Beckett")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraToc"
  }, [_c('span', {
    attrs: {
      "href": "#/33_chapter05#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5 Lord Chelmsford – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by John Laband")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraToc"
  }, [_c('span', {
    attrs: {
      "href": "#/36_chapter06#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6 Charles Gordon – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Gerald Herman")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraToc"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter07#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7 Frederick Roberts – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by André Wessels")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraToc1"
  }, [_c('span', {
    attrs: {
      "href": "#/48_chapter08#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8 Herbert Kitchener – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by Keith Surridge")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraToc"
  }, [_c('span', {
    attrs: {
      "href": "#/55_appendix#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix Chronology of Victorian Wars")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-444fd4de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_contents.vue
// module id = 66
// module chunks = 0